import React from 'react';
import { IonIcon } from '@ionic/react';
import { searchOutline } from 'ionicons/icons';

export default function NoDataFoundOrSelectedDiv({ isDetailPanel = false }) {
    return (
        <div className="no-data-container">
            <IonIcon icon={searchOutline} className="no-data-icon" />
            <h3 className="no-data-title">
                {isDetailPanel ? 'No Item Selected' : 'No Data Found'}
            </h3>
            <p className="no-data-subtext">
                {isDetailPanel ? 'Please select an item to view details.' : 'There is nothing to show at the moment.'}
            </p>
        </div>
    );
}
